import ApplicationController from "./application_controller"

// Controller for modal windows
// Usage:
// <div data-controller="modal" class="modal">
//   <button data-action="click->modal#open">Open</button>
//   <div data-modal-target="container" class="modal-container hidden">
//     <div class="modal-content">
//       <button data-action="click->modal#close">&times;</button>
//       <!-- Modal content -->
//     </div>
//   </div>
// </div>

export default class extends ApplicationController {
  static targets = [ "container" ]
  static values = {
    backdropClose: { type: Boolean, default: true },
    escapeClose: { type: Boolean, default: true }
  }

  connect() {
    this.boundKeyHandler = this.handleKeydown.bind(this)
    this.boundBackdropClick = this.handleBackdropClick.bind(this)
  }

  disconnect() {
    this.close()
  }

  open(event) {
    event?.preventDefault()

    this.containerTarget.classList.remove('hidden')
    document.body.classList.add('modal-open')

    // Add event listeners
    if (this.escapeCloseValue) {
      document.addEventListener('keydown', this.boundKeyHandler)
    }

    if (this.backdropCloseValue) {
      this.containerTarget.addEventListener('click', this.boundBackdropClick)
    }

    this.dispatch("modal:opened")

    // Focus on the first interactive element
    const firstInput = this.containerTarget.querySelector('input, button, select, textarea')
    if (firstInput) {
      firstInput.focus()
    }
  }

  close(event) {
    event?.preventDefault()

    this.containerTarget.classList.add('hidden')
    document.body.classList.remove('modal-open')

    // Remove event listeners
    document.removeEventListener('keydown', this.boundKeyHandler)
    this.containerTarget.removeEventListener('click', this.boundBackdropClick)

    this.dispatch("modal:closed")
  }

  toggle(event) {
    event?.preventDefault()

    if (this.containerTarget.classList.contains('hidden')) {
      this.open()
    } else {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }

  handleBackdropClick(event) {
    // Close only if the click was on the container itself, not on the content
    if (event.target === this.containerTarget) {
      this.close()
    }
  }
}
